import { EntityType } from "@tvg/ts-types/Alerts";
import { EntityIdEnum, MyStableConfig, MyStableEntityTypes } from "./types";

export const MY_STABLE_VIEW_OPTIONS = [
  { id: "runner", label: "Horses" },
  { id: "jockey", label: "Jockeys" },
  {
    id: "trainer",
    label: "Trainers"
  },
  { id: "owner", label: "Owners" }
];

export const MY_STABLE_DATA_FIELDS: Record<MyStableEntityTypes, EntityIdEnum> =
  {
    [EntityType.Runner]: EntityIdEnum.Runners,
    [EntityType.Jockey]: EntityIdEnum.Jockeys,
    [EntityType.Trainer]: EntityIdEnum.Trainers,
    [EntityType.Owner]: EntityIdEnum.Owners
  };

export const MY_STABLE_TAB_MENU = [
  { id: "manage", label: "Manage" },
  { id: "search", label: "Search" }
];

export const MY_STABLE_FAQ = {
  title: "My Stable FAQ",
  faqMessages: [
    {
      title: "What is My Stable?",
      content:
        "My Stable is the place where you can configure notifications which will keep you informed around all of your favorite horses, jockeys, trainers and owners."
    },
    {
      title: "Race Alert Email Management",
      content:
        "Race Alerts can be enabled or disabled without changing your configured alerts, so turning off alerts will not affect your preferences set on this page. When disabled, alerts will be skipped; when re-enabled, upcoming race alerts will be sent. Use the Race Alerts setting above to activate/deactivate the ability to receive race alert emails, which can be updated at any time. When alerts are turned on, you may edit the email address to which race alerts will be sent. Your email address used when you signed up will be used by default but can be changed if you would prefer to use another address. Please click on the Save button to save any changes you make."
    },
    {
      title: "How to set up Favorites",
      content:
        "When you have selected the tab you are looking for (Horses / Jockeys / Trainers / Owners), either use the search box to find a specific entry or the popular selections underneath. Once you have found a selection you would like to receive alerts on, click the notification (bell) icon."
    }
  ]
};

export const MY_STABLE_ERROR_MESSAGES = {
  ERR_REMOVE:
    "Sorry, we weren’t able to remove this entry. Please try again later.",
  ERR_UNKNOWN: "An unknown error occurred. Please contact support.",
  ERR_FOLLOW:
    "Sorry, we weren’t able to add this entry. Please try again later."
};

export const MY_STABLE_SEARCH_RESULTS_AMOUNT = 25;

const MY_STABLE_SEARCH = {
  inputLabel: "#entity# Search",
  inputPlaceholder: "#entity# name...",
  emptyMessage:
    "Enter your horse, jockey, trainer or owner name, add entries to your stable and set your alerts.",
  info: "Only the top #resultsAmount# results are shown. Please refine your search if you do not see what you are looking for. Some search results may already be in your stable.",
  resultsAmount: MY_STABLE_SEARCH_RESULTS_AMOUNT,
  success: "#entity# has been successfully added to your stable.",
  notFound:
    "Couldn't find '#entity#'. Check your spelling or try a different search query."
};

export const MY_STABLE_CONFIG: MyStableConfig = {
  title: "My Stable",
  header:
    "My stable is the place where you keep your favorite horses, jockeys, trainers and owners.",
  body: "You also can configure notifications to keep you informed.",
  allAlerts: "ALL ALERT NOTIFICATIONS",
  viewByLabel: "View by",
  viewByOptions: MY_STABLE_VIEW_OPTIONS,
  tabMenu: MY_STABLE_TAB_MENU,
  myStableFAQ: MY_STABLE_FAQ,
  myStableSearch: MY_STABLE_SEARCH,
  emptyMessage:
    "There are no #entity# to manage in your stable. Please search and add #entity#",
  showEntries: "Showing #displayedCount# entries out of #totalCount#",
  confirmationModal: {
    title: "Remove #entity#",
    description: "Are you sure you want to remove #entityName#?"
  },
  errorMessages: MY_STABLE_ERROR_MESSAGES
};
